(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-drip-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sp-drip-builder')) {
  customElements.define('sp-drip-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.initialised = true;
      this.scope = this.closest('[data-sp-drip-scope]') || this.form;
      this.size = this.querySelector('[data-drip-size]');
      this.notes = this.querySelector('[data-drip-notes]');
      this.addons = [...this.querySelectorAll('[data-drip-addon]')];
      this.error = this.querySelector('[data-drip-error]');
      this.button = this.form.querySelector('button[type="submit"]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.size.addEventListener('change', () => this.sync());
      this.quantity?.addEventListener('input', () => this.sync());
      this.quantity?.addEventListener('change', () => this.sync());
      this.notes.addEventListener('input', () => this.validateDreamColour());
      this.querySelectorAll('[data-drip-colour]').forEach(input => input.addEventListener('change', () => this.validateDreamColour()));
      this.addons.forEach(check => check.addEventListener('change', () => {
        const detail = this.querySelector('[data-drip-detail="' + check.dataset.dripAddon + '"]');
        if (detail) {
          detail.hidden = !check.checked;
          const input = detail.querySelector('input');
          input.disabled = !check.checked;
          input.required = check.checked;
        }
        this.sync();
      }));
      this.onSubmit = event => {
        if (event.target !== this.form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.add();
      };
      this.onClick = event => {
        const button = event.target.closest('button[type="submit"],input[type="submit"]');
        if (!button || button.form !== this.form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.add();
      };
      window.addEventListener('submit', this.onSubmit, true);
      window.addEventListener('click', this.onClick, true);
      const removeLegacy = () => this.scope.querySelectorAll('#bcpo,.best-custom-product-options').forEach(element => element.remove());
      removeLegacy();
      this.observer = new MutationObserver(removeLegacy);
      this.observer.observe(this.scope, { childList:true, subtree:true });
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('submit', this.onSubmit, true);
      window.removeEventListener('click', this.onClick, true);
      this.observer?.disconnect();
      this.initialised = false;
    }
    validateDreamColour() {
      const dream = this.querySelector('[data-drip-colour="dream"]:checked');
      this.notes.setCustomValidity(dream && !this.notes.value.trim() ? this.dataset.dreamError : '');
    }
    sync() {
      const option = this.size.selectedOptions[0];
      const quantity = Math.max(1, Number(this.quantity?.value || 1));
      const extras = this.addons.filter(check => check.checked).length * 400;
      const price = Number(option?.dataset.price || 0);
      this.querySelector('[data-drip-total]').textContent = new Intl.NumberFormat('en-AU', {style:'currency',currency:this.dataset.currency || 'AUD'}).format((price + extras) * quantity / 100);
      this.scope.querySelectorAll('.price__current .js-value').forEach(element => element.textContent = option?.dataset.money || '');
      if (this.button) this.button.disabled = this.busy || !option || option.disabled;
      if (this.quantity) { this.quantity.min = '1'; this.quantity.step = '1'; }
    }
    async add() {
      if (this.busy) return;
      this.validateDreamColour();
      this.sync();
      if (!this.form.reportValidity() || this.size.selectedOptions[0]?.disabled) return;
      const properties = {};
      for (const [key,value] of new FormData(this.form)) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value).trim();
      }
      const quantity = Number(this.quantity?.value || 1);
      const items = [{id:Number(this.size.value),quantity,properties}];
      this.addons.filter(check => check.checked).forEach(check => {
        const detail = this.querySelector('[data-drip-detail="' + check.dataset.dripAddon + '"] input');
        const addonProperties = { 'For cake':this.dataset.cake };
        if (detail) addonProperties[check.dataset.dripAddon === 'name' ? 'Name for SmashCake' : 'Birthday number'] = detail.value.trim();
        items.push({id:Number(check.dataset.variant),quantity,properties:addonProperties});
      });
      this.busy = true;
      this.error.hidden = true;
      this.sync();
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error();
        window.location.assign(this.dataset.cartUrl);
      } catch {
        this.busy = false;
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.sync();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
